import React from "react";

export const ProfileCard = ({ children, className }) => {
  return (
    <div
      className={`p-6 sm:py-14 sm:px-10 bg-white shadow-wce-soft rounded-2xl 
        min-h-[540px] ${className}`}
    >
      {children}
    </div>
  );
};
